import type { Cue } from "../engine.ts";
import { TRIM } from "../levels.ts";
import { bell, click, noise, tone, trim, whoosh } from "../synth.ts";
import { hz } from "../theory.ts";

/** Menu sounds: crisp and quiet. The interface is steel and glass like the HUD, never brass. */

export const hover: Cue = trim(TRIM.ui.hover, (o) => {
  tone(o, { f: 2400, gain: 0.025, d: 0.012 });
  return 0.03;
});

export const press: Cue = trim(TRIM.ui.press, (o) => {
  click(o, 0.08, 4000, 0.003);
  tone(o, { f: 1320, gain: 0.045, d: 0.025 });
  tone(o, { f: 1760, gain: 0.045, d: 0.035, delay: 0.035 });
  return 0.1;
});

export const back: Cue = trim(TRIM.ui.back, (o) => {
  click(o, 0.06, 3500, 0.003);
  tone(o, { f: 1760, gain: 0.04, d: 0.025 });
  tone(o, { f: 1175, gain: 0.04, d: 0.035, delay: 0.035 });
  return 0.1;
});

export const toggle =
  (on: boolean): Cue =>
  trim(TRIM.ui.toggle, (o) => {
    click(o, 0.07, on ? 4200 : 2800, 0.003);
    tone(o, { f: on ? 1760 : 1320, gain: 0.03, d: 0.02 });
    return 0.05;
  });

export const panel =
  (open: boolean): Cue =>
  trim(TRIM.ui.panel, (o) => {
    whoosh(o, 0.06, open ? 700 : 2200, open ? 2200 : 700, 0.12);
    return 0.15;
  });

export const toast =
  (error: boolean): Cue =>
  trim(error ? TRIM.ui.toastError : TRIM.ui.toast, (o) => {
    if (error) {
      tone(o, { type: "triangle", f: hz(13), gain: 0.05, d: 0.12 });
      tone(o, { type: "triangle", f: hz(12), gain: 0.05, d: 0.2, delay: 0.09 });
      return 0.35;
    }
    bell(o, hz(19), 0.12, 0.3);
    bell({ ...o, t: o.t + 0.06 }, hz(24), 0.15, 0.3);
    return 0.6;
  });

export const chat: Cue = trim(TRIM.ui.chat, (o) => {
  tone(o, { f: 1480, gain: 0.03, d: 0.03 });
  noise(o, { color: "white", type: "highpass", f: 6000, gain: 0.02, d: 0.01 });
  return 0.06;
});
